// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-item-actions[data-v-2ec0ca58]{display:flex}.show-more-btn[data-v-2ec0ca58]{background:transparent;border:none;padding:0;font-size:14px;text-decoration:underline;font-weight:600}.ml-24[data-v-2ec0ca58]{margin-left:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
